import React, { memo, useCallback } from 'react';
import ShareDialog from "../ShareDialog";
import Toast from "../Toast";
import { isWeMeetApp, loadScript } from '@tencent/web-base';
import copy from 'copy-to-clipboard';
import { setShareInfo } from "./share-util";
export let ShareListId = /*#__PURE__*/function (ShareListId) {
  ShareListId["wx"] = "WECHAT";
  ShareListId["wxMoment"] = "WECHAT_TIMELINE";
  ShareListId["qq"] = "QQ";
  ShareListId["wework"] = "WEWORK";
  ShareListId["copy"] = "copy";
  return ShareListId;
}({});
export let ShareType = /*#__PURE__*/function (ShareType) {
  ShareType["normal"] = "NORMAL";
  ShareType["wechatMp"] = "WECHAT_MP";
  ShareType["image"] = "IMAGE";
  return ShareType;
}({});

/** app分享方法的渠道 */
export let ChannelType = /*#__PURE__*/function (ChannelType) {
  ChannelType[ChannelType["qq"] = 1] = "qq";
  ChannelType[ChannelType["wechat"] = 2] = "wechat";
  ChannelType[ChannelType["wework"] = 3] = "wework";
  ChannelType[ChannelType["wxMoment"] = 10] = "wxMoment";
  return ChannelType;
}({});

/** 分享接口数据 */

export const DEFAULT_LIST = [{
  name: '微信',
  icon: 'https://cdn.calendar.tencent.com/calendar_res/wx.svg',
  id: ShareListId.wx
}, {
  name: '朋友圈',
  icon: 'https://cdn.calendar.tencent.com/calendar_res/moments.svg',
  id: ShareListId.wxMoment
}, {
  name: 'QQ',
  icon: 'https://cdn.calendar.tencent.com/calendar_res/qq.png',
  id: ShareListId.qq
}, {
  name: '企业微信',
  icon: 'https://cdn.calendar.tencent.com/calendar_res/wx_work.svg',
  id: ShareListId.wework
}, {
  name: '复制链接',
  icon: 'https://cdn.calendar.tencent.com/calendar_res/activity/link_copy.svg',
  id: ShareListId.copy
}];
export const APP_SHARE_CHANNEL_MAP = {
  [ShareListId.qq]: {
    channel: ChannelType.qq
  },
  [ShareListId.wework]: {
    channel: ChannelType.wework
  },
  [ShareListId.wx]: {
    channel: ChannelType.wechat
  },
  [ShareListId.wxMoment]: {
    channel: ChannelType.wxMoment
  }
};

/** 微信、qq等外部应用分享方法 */
export const externalShare = setShareInfo;
const Share = props => {
  const {
    shareList = DEFAULT_LIST,
    onClick,
    visible,
    onClose,
    shareTitle = '分享标题',
    shareDesc = '分享描述',
    shareUrl = '',
    shareImageUrl = 'https://cdn.calendar.tencent.com/calendar_res/activity/place-logo-yd.png',
    showToast = true
  } = props;
  const appShare = useCallback(id => {
    const shareData = {
      channel: APP_SHARE_CHANNEL_MAP[id]?.channel,
      // @ts-ignore
      type: wemeet.ExternalShareType.NORMAL,
      title: shareTitle,
      desc: shareDesc,
      imageUrl: shareImageUrl,
      shareUrl: shareUrl || location.href
    };
    wemeet.ui.shareToExternalApp(shareData).catch(err => {
      console.log(err);
      if (typeof window === 'undefined') return;
      window.nextAegis?.error(`[app share error]: ${JSON.stringify(err)}`);
    });
  }, [props]);

  // 点击事件
  const handleClick = useCallback(id => {
    if (typeof window === 'undefined') return;
    if (APP_SHARE_CHANNEL_MAP[id]) {
      // 调用app方法
      if (!isWeMeetApp()) {
        showToast && Toast.show('请在会议app中使用');
        return;
      }
      // 没有加载js
      if (typeof wemeet === 'undefined') {
        loadScript('https://cdn.meeting.tencent.com/jssdk/wemeet-js-sdk-1.0.57.js').then(() => {
          appShare(id);
        }, err => {
          console.log(err);
        });
      } else {
        appShare(id);
      }
    }
    if (id === ShareListId.copy) {
      copy(shareUrl || location.href);
      showToast && Toast.show('复制成功');
    }
    onClick?.(id);
  }, [onClick, appShare, shareUrl]);
  const handleClose = useCallback(() => {
    onClose?.();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "cc-share"
  }, /*#__PURE__*/React.createElement(ShareDialog, {
    visible: visible,
    onClick: handleClick,
    onClose: handleClose,
    type: "activity",
    targets: shareList
  }));
};
Share.displayName = 'cc-share';
export default /*#__PURE__*/memo(Share);